<!--    
    Implemented by Renuka chama
    16/10/2025
    code implemented to add view condition popup.
   -->

<div class="popup marginBottomStyle" 
     style="position: relative; overflow: hidden; height: 100%;">
  
  <div style="padding-bottom: 8px; margin-bottom: 15px;">
    <label 
      i18n="@@spmsUserReg" 
      class="textColour" 
      style="font-weight: 500; font-size: larger; color: black;">
      Column Filter Conditions
    </label>
  </div>

  <div class="container-fluid" style="max-height: 60vh; overflow-y: auto; overflow-x: hidden;">
    <div class="row">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead>
            <tr style="border-top: 1px solid #dee2e6;">
              <th class="th-lg">Object</th>
              <th class="th-lg">Attribute</th>
              <th class="th-lg">Condition</th>
              <th class="th-lg">Value</th>
              <th class="th-lg text-center">Remove</th>
            </tr>
          </thead>

          <tbody *ngIf="tempFilters?.length > 0">
            <tr *ngFor="let cond of tempFilters; let i = index">
              <td class="conditionsalign">{{ cond.objectWhere }}</td>
              <td class="conditionsalign">{{ cond.whereKeyAlias }}</td>
              <td class="conditionsalign">{{ cond.whereCondition }}</td>
              <td class="conditionsalign">
                {{ cond.whereValue }} {{ cond.whereValue1 }}
              </td>
              <td class="conditionsalign text-center">
                <label class="CloseButtonStyle">
                  <span>
                    <em class="fas fa-minus"
                        style="color: white; background: red; padding: 3px 5px; border-radius: 10px; cursor: pointer;"
                        title="Remove Condition"
                        (click)="removeCondition(i)">
                    </em>
                  </span>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <div class="d-flex justify-content-end mt-3">
      <button 
        i18n="@@TMRunButton"
        type="button"
        (click)="update()"
        title="Update"
        class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        style="padding: .4rem 1.6rem; font-weight: 500;"
        [style.background-color]="backgroundColorButton"
        [style.border-color]="backgroundColorButton">
        Update
      </button>

        <button 
    type="button"
    (click)="close()"
    title="Close"
    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
    style="padding: .4rem 1.6rem; font-weight: 500; background: white; color: black;"
    [style.border-color]="backgroundColorButton">
    Close
  </button>
    </div>

  </div>
</div>
